import React from 'react';

interface ChatMessageProps {
  message: string;
  time: string;
  isSent: boolean;
  senderAvatarUrl?: string;
  attachmentImageUrl?: string;
  attachmentFileName?: string;
}

const ChatMessage: React.FC<ChatMessageProps> = ({
  message,
  time,
  isSent,
  senderAvatarUrl,
  attachmentImageUrl,
  attachmentFileName,
}) => {
  return (
    <div className={`flex gap-3 max-w-[80%] ${isSent ? 'self-end flex-row-reverse' : ''}`}>
      {!isSent && senderAvatarUrl && (
        <img className="w-8 h-8 rounded-lg object-cover flex-shrink-0" alt="Avatar" src={senderAvatarUrl} />
      )}
      {isSent && (
        <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center text-on-primary font-bold text-[10px] flex-shrink-0">YOU</div>
      )}
      <div className={`flex flex-col ${isSent ? 'items-end' : ''}`}>
        <div className={`${isSent ? 'bg-primary text-on-primary rounded-tl-xl rounded-b-xl' : 'bg-surface border border-outline-variant rounded-tr-xl rounded-b-xl'} p-4 shadow-sm`}>
          <p className="text-body-md">{message}</p>
          {attachmentImageUrl && (
            <div className="rounded-lg overflow-hidden border border-outline-variant mt-3">
              <img className="w-full h-48 object-cover" alt="Attachment" src={attachmentImageUrl} />
              {attachmentFileName && (
                <div className="bg-surface p-2 flex items-center justify-between">
                  <span className="text-label-md font-label-md text-on-surface-variant truncate">{attachmentFileName}</span>
                  <span className="material-symbols-outlined text-[18px] text-primary" data-icon="download">download</span>
                </div>
              )}
            </div>
          )}
        </div>
        <span className="text-[10px] text-outline font-label-md mt-1 block">{time} {isSent && '• Read'}</span>
      </div>
    </div>
  );
};

export default ChatMessage;